import EditFlight from './EditFlight';

export default EditFlight;
